export const SearchBarMagnifyingGlassIcon = ({
                                               className,
                                               style,
                                               size = '1.3em',
                                               color = '#111'
                                             }) => {
  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="-1 -1 27 25"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <g transform="translate(1 1)"
         stroke={color}
         strokeWidth="1.8"
         fill="none"
        // fillRule='evenodd'
      >
        <ellipse cx="9.274" cy="9.275" rx="9.274" ry="9.275"/>
        <path d="m16.358 16.04 5.979 4.927" strokeLinecap="round"/>
      </g>
    </svg>
  );
};
